export default __webpack_public_path__ + "static/media/Trie.cf0926ff.png";